import { MainActions, MainActionTypes } from './main.actions';
import { MainStateInterface, MenuInterface } from './main.model';
import { IGenericObject } from '../../shared/model/interface/generic.model';
import { HelperService } from '../../shared/service/helper.service';

export const initialState: MainStateInterface = {
  getActiveSitesLoading: false,
  getActiveSitesLoaded: false,
  getNavigationMenuLoading: false,
  getNavigationMenuLoaded: false,
  sendContactSupportLoading: false,
  authorizedPages: [],
  menu: { menus: [], clientLogo: '', singleSiteAndLine: false },
  activeSites: [],
  clientLogo: null,
  singleSiteAndLine: false,
  useNewMenu: false,
  getCustomMailGroupsLoading: false,
  getCustomMailGroupsLoaded: false,
  customMailGroups: null,
  allowedDomainsLoading: false,
  allowedDomainsLoaded: false,
  allowedDomains: [],
  rolesLoading: false,
  rolesLoaded: false,
  roles: [],
  activeSiteModules: {},
};

export function mainReducer(state = initialState, action: MainActions): MainStateInterface {
  switch (action.type) {
    case MainActionTypes.GetActiveSites:
      return {
        ...state,
        getActiveSitesLoading: true,
        getActiveSitesLoaded: false,
      };
    case MainActionTypes.GetActiveSitesCompleted:
      return {
        ...state,
        getActiveSitesLoading: false,
        getActiveSitesLoaded: true,
        activeSites: action.data,
      };
    case MainActionTypes.SetSiteModuleStatuses:
      return {
        ...state,
        activeSiteModules: action.data,
      };
    case MainActionTypes.GetNavigationMenu:
      return {
        ...state,
        getNavigationMenuLoading: true,
        getNavigationMenuLoaded: false,
      };

    case MainActionTypes.GetNavigationMenuCompleted:
      return {
        ...state,
        getNavigationMenuLoading: false,
        getNavigationMenuLoaded: true,
        authorizedPages: action.data.menus
          .filter((node: MenuInterface) => node.link !== '#' && !node.external)
          .map((node: MenuInterface) => node.link),
        menu: action.data,
        menuItemHash: (action.data?.menus ?? []).reduce((menuItemHash: IGenericObject<MenuInterface>, menuItem) => {
          menuItemHash[menuItem.id] = HelperService.cloneDeep(menuItem);
          return menuItemHash;
        }, {}),
        clientLogo: action.data.clientLogo,
        singleSiteAndLine: action.data.singleSiteAndLine,
        // useNewMenu is no longer returned by the API → stays false (initial state);
        // the new menu is opt-in via the localStorage override (sitemap switch button).
      };

    case MainActionTypes.SendContactSupport:
      return {
        ...state,
        sendContactSupportLoading: true,
      };

    case MainActionTypes.SendContactSupportCompleted:
      return {
        ...state,
        sendContactSupportLoading: false,
      };

    case MainActionTypes.GetCustomMailGroups:
      return {
        ...state,
        ...{
          getCustomMailGroupsLoading: true,
          getCustomMailGroupsLoaded: false,
        },
      };

    case MainActionTypes.GetCustomMailGroupsCompleted:
      return {
        ...state,
        ...{
          customMailGroups: action.data,
          getCustomMailGroupsLoading: false,
          getCustomMailGroupsLoaded: true,
        },
      };

    case MainActionTypes.AllowedDomains:
      return {
        ...state,
        ...{
          allowedDomainsLoading: true,
          allowedDomainsLoaded: false,
        },
      };

    case MainActionTypes.AllowedDomainsCompleted:
      return {
        ...state,
        ...{
          allowedDomainsLoading: false,
          allowedDomainsLoaded: true,
          allowedDomains: action.data,
        },
      };

    case MainActionTypes.Roles:
      return {
        ...state,
        ...{
          rolesLoading: true,
          rolesLoaded: false,
        },
      };

    case MainActionTypes.RolesCompleted:
      return {
        ...state,
        ...{
          rolesLoading: false,
          rolesLoaded: true,
          roles: action.data,
        },
      };

    default:
      return state;
  }
}
